import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { NewAppointmentContext } from "../context/newAppointmentContext";
import NewAppointmentProps from "../interface/newAppointmentProps";

const SearchParticipant = (): React.JSX.Element => {
  const {
    newAppointment,
    setNewAppointment,
    startSearch,
  }: {
    newAppointment: NewAppointmentProps;
    setNewAppointment: (newAppointment: NewAppointmentProps) => void;
    startSearch: () => void;
  } = React.useContext(NewAppointmentContext);

  const handleOnInput = (event: any): void => {
    setNewAppointment({
      ...newAppointment,
      search: {
        ...newAppointment.search,
        participantName: event.target.value,
      },
    });

    if (newAppointment.search.loading) return;
    if (event.target.value.length < 2) return;

    startSearch();
  };

  const handleOnChange = (_event: any, option: any): void => {
    setNewAppointment({
      ...newAppointment,
      search: {
        ...newAppointment.search,
        selectedParticipant: option,
      },
    });
  };

  return (
    <Autocomplete
      loading={newAppointment.search.loading}
      loadingText="Suche..."
      disablePortal
      noOptionsText="Bitte mindestens 2 Zeichen eingeben."
      id="seqarchParticipantInput"
      options={newAppointment.search.searchResults}
      value={newAppointment.search.selectedParticipant}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onInput={handleOnInput}
      onChange={handleOnChange}
      renderInput={(params) => (
        <TextField color="success" {...params} label="Teilnehmer:in" />
      )}
    />
  );
};

export default SearchParticipant;
